import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
  uploadItem,
  uploadValidate,
} from "./uomSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  showDialog,
  formatterStatus,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import { headerSortingClasses, sortCaret } from "../../../_metronic/_helpers";
import BootstrapTable from "react-bootstrap-table-next";
import { fetchTemplate, selectLoadingTemplate } from "../product/productSlice";

export const UomCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const loading2 = useSelector(selectLoadingTemplate);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const { id } = useParams();
  const ref = useRef();

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [reffUom, setReffUom] = useState("");

  const paramsId = {
    uom_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setName(dataId?.uom_description);
      setCode(dataId?.uom_code);
      setReffUom(dataId?.reff_uom_id);
    }
  }, [dataId]);

  const handleSave = async () => {
    if (name === "" || code === "") {
      return showDialog("Please Input Field Mandatory ");
    }
    const params = {
      company_id: user.company_id,
      uom_id: id,
      uom_description: name,
      uom_code: code,
      reff_uom_id: reffUom,
    };
    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  // upload
  const [showUpload, setShowUpload] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [tableUpload, setTableUpload] = useState([]);

  const handleShowUpload = (data) => {
    setShowUpload(true);
  };

  const handleCloseUpload = () => {
    setTableUpload([]);
    setShowUpload(false);
  };

  const handleUpload = async () => {
    const params = tableUpload.filter(
      (entry) => entry.status_validation === "Success"
    );

    if (params.length === 0) {
      return showDialog("Please upload data first");
    }

    try {
      const response = await dispatch(uploadItem(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchId, dispatch);
        handleCloseUpload();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileUpload(selectedFile);
    validateFile(selectedFile);
  };

  const validateFile = async (file) => {
    if (file) {
      try {
        const response = await dispatch(uploadValidate(file));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const initData = response.payload.data.data.map((item, index) => {
            return {
              ...item,
              no: index + 1,
            };
          });
          setTableUpload(initData);
        } else {
          showErrorDialog(response.payload.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
        console.log(error.message);
      }
    } else {
      console.log("No file uploaded");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      style: { minWidth: "60px" },
    },

    {
      text: "code",
      dataField: "uom_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "description",
      dataField: "uom_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "status",
      dataField: "status_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatterStatus,
    },
    {
      text: "message",
      dataField: "message_validation",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
  ];

  const handleDownload = async () => {
    const params = {
      file_type: "UOM",
    };
    try {
      const response = await dispatch(fetchTemplate(params));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/xlsx",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "UOM.xlsx";
        link.click();
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  return loading || loading2 ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create UOM" : "Edit UOM"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            {id === undefined && (
              <Button
                className="btn btn-warning mr-3"
                onClick={handleShowUpload}
              >
                Upload
              </Button>
            )}
            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Uom Code<b className="color-red">*</b>
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setCode(e.target.value)}
                      value={code}
                      disabled={id !== undefined ? true : false}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Reff Uom</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setReffUom(e.target.value)}
                      value={reffUom}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>
                      Uom Description <b className="color-red">*</b>{" "}
                    </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>

      <Modal
        show={showUpload}
        onHide={handleCloseUpload}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload UOM</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>
                    File <b className="color-red">*</b>
                  </b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    ref={ref}
                    type="file"
                    label="Input "
                    onChange={handleFileChange}
                    custom
                    accept=".xlsx"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Button variant="warning" onClick={() => handleDownload()}>
                Download Template
              </Button>
            </Col>
          </Form.Group>

          {tableUpload.length > 0 && (
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-5"
              bootstrap4
              keyField="no"
              data={tableUpload}
              columns={columns}
              hover
              striped
            ></BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseUpload()}>
            Close
          </Button>
          <Button variant="danger" onClick={handleUpload}>
            Save
          </Button>{" "}
        </Modal.Footer>
      </Modal>
    </>
  );
};
